import React, { ReactNode, createContext, use } from 'react'
import { useXMPPClientContext } from '../xmpp-client/XMPPClientContext'
import { RoomId, ParsedBlock } from './types'
import { useRoomDataAndEffects } from './useRoomDataAndEffects'

interface Context {
  events: Array<ParsedBlock>
  isInitial: boolean
}

const RoomDataBaseContext = createContext<Context>({
  events: [],
  isInitial: false,
})

const useRoomDataContext = () => {
  return use(RoomDataBaseContext)
}

export { useRoomDataContext }

export const RoomDataProvider = ({
  children,
  isMine,
  roomId,
}: {
  children?: ReactNode
  isMine: boolean
  roomId: RoomId
}) => {
  const { client, publicClient } = useXMPPClientContext()
  const events = isMine ? client.events : publicClient.events

  const value = useRoomDataAndEffects({
    roomId: roomId,
    events,
    guestId: client.userId,
    botId: 'bot',
    initialEvents: events['initial'],
  })

  return <RoomDataBaseContext value={value}>{children}</RoomDataBaseContext>
}
